var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"box_col-1 user noborder btn-gray-white",class:{ 'active' : _vm.isOpen },attrs:{"href":"javascript:void(0)"},on:{"click":_vm.open}},[_c('i',{staticClass:"icon-user"})])}
var staticRenderFns = []

export { render, staticRenderFns }